export default {
  FETCH_MESSAGES_LOADING: 'FETCH_MESSAGES_LOADING',
  FETCH_MESSAGES_FAILED: 'FETCH_MESSAGES_FAILED',
  FETCH_MESSAGES_SUCCESS: 'FETCH_MESSAGES_SUCCESS',
  FETCH_MESSAGES_REJECT: 'FETCH_MESSAGES_REJECT',

  FETCH_MESSAGE_RECEIVERS_LOADING: 'FETCH_MESSAGE_RECEIVERS_LOADING',
  FETCH_MESSAGE_RECEIVERS_FAILED: 'FETCH_MESSAGE_RECEIVERS_FAILED',
  FETCH_MESSAGE_RECEIVERS_SUCCESS: 'FETCH_MESSAGE_RECEIVERS_SUCCESS',
  FETCH_MESSAGE_RECEIVERS_REJECT: 'FETCH_MESSAGE_RECEIVERS_REJECT',


  FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_LOADING: 'FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_LOADING',
  FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_FAILED: 'FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_FAILED',
  FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_SUCCESS: 'FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_SUCCESS',
  FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_REJECT: 'FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_REJECT',

  SEND_MESSAGE_LOADING: 'SEND_MESSAGE_LOADING',
  SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_REJECT: 'SEND_MESSAGE_REJECT',
  SEND_MESSAGE_FAILED: 'SEND_MESSAGE_FAILED',

  FETCH_MESSAGE_BY_ID_SUCCESS: 'FETCH_MESSAGE_BY_ID_SUCCESS',
  FETCH_MESSAGE_BY_ID_LOADING: 'FETCH_MESSAGE_BY_ID_LOADING',
  FETCH_MESSAGE_BY_ID_REJECT: 'FETCH_MESSAGE_BY_ID_REJECT',
  FETCH_MESSAGE_BY_ID_FAILED: 'FETCH_MESSAGE_BY_ID_FAILED',

  EMPTY_MESSAGE_OBJECT: 'EMPTY_MESSAGE_OBJECT'
};